import Multiclient from "components/Core/Multiclient"

const RememberScreen = (props: any) => {
  return <Multiclient path_override="components/User/Remember/RememberForm" />
}

export default RememberScreen
